import { UserDTO } from "../../Models";
import { action, computed, observable, runInAction } from "mobx";
import { FieldType, ViewModelBase } from "@shoothill/core";
import { DashboardModel } from "../../Models/Domain/Dashboard/DashboardModel";
import { StoresInstance } from "../../Stores";

// App
import { AppUrls } from "AppUrls";
import { ApplicantUsersLiteAndRelatedDTO } from "Globals/Models/DTO/ApplicantUsersLiteAndRelatedDTO";
import { ApplicantUserLite } from "Globals/Models/ApplicantUserLite";

export interface AdminApplicantTableDataModel {
    id: string;
    name: string;
    email: string;
    phone: string;
    registrationSent: boolean;
    registeredDate: string;
    numberOfApplications: number;
    status: string;
}

export default class AdminApplicantsListViewModel extends ViewModelBase {
    @observable public applicantUsers: ApplicantUserLite[] = [];
    constructor() {
        super();
        this.loadData("");
    }

    @action
    public async loadData(query: string): Promise<void> {
        this.setIsLoading(true);
        const path = AppUrls.Server.Admin.SearchAllApplicantUsers + "/?search=" + query;
        const apiResult = await this.Get<ApplicantUsersLiteAndRelatedDTO>(path);
        if (apiResult.wasSuccessful) {
            runInAction(() => {
                this.applicantUsers = apiResult.payload.applicantUsers;
            });
        }
        this.setIsLoading(false);
    }

    @action
    public async deleteApplicant(id: string): Promise<void> {
        this.setIsLoading(true);
        const path = AppUrls.Server.Admin.DeleteApplicantUser + "/?id=" + id;
        const apiResult = await this.Get<UserDTO>(path);
        if (apiResult.wasSuccessful) {
            let user = this.applicantUsers.find((user) => user.id === id);
            runInAction(() => {
                if (user != undefined) {
                    this.applicantUsers.splice(this.applicantUsers.indexOf(user), 1);
                }
            });
        }
        this.setIsLoading(false);
    }

    @computed
    public get getTableData() {
        let tableData: AdminApplicantTableDataModel[] = [];
        this.applicantUsers.forEach((applicantUser) => {
            tableData.push({
                id: applicantUser.id ? applicantUser.id : "",
                name: applicantUser.firstName + " " + applicantUser.surname,
                email: applicantUser.email,
                phone: applicantUser.phoneNumber,
                registrationSent: applicantUser.registrationSent,
                registeredDate: new Date(applicantUser.registered).toLocaleDateString("en-GB"),
                numberOfApplications: applicantUser.applications,
                status: applicantUser.applicantStatusId,
            });
        });
        return tableData;
    }

    public async isFieldValid(fieldName: keyof FieldType<DashboardModel>, value: any): Promise<boolean> {
        let { isValid, errorMessage } = await this.validateDecorators(fieldName);

        this.setError(fieldName, errorMessage);
        this.setValid(fieldName, isValid);

        return isValid;
    }

    public afterUpdate: undefined;
    public beforeUpdate: undefined;
}
